import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ProjectService } from './project.service';

/** Resolves the requested branch to a branch that is available for a project. */
@Injectable({ providedIn: 'root' })
export class BranchContextService {
  private readonly projectService = inject(ProjectService);

  resolve(projectId: string, requestedBranch: string | null): Observable<string | null> {
    return this.projectService.get$(projectId).pipe(
      map(project => {
        const branches = project.branches ?? [];
        const requested = requestedBranch?.trim();
        if (requested && branches.some(branch => branch.branchName === requested)) {
          return requested;
        }

        return project.defaultBranch ?? branches[0]?.branchName ?? null;
      })
    );
  }
}
